import { render, staticRenderFns } from "./ViewMachineResources.vue?vue&type=template&id=15b05ccb&scoped=true&"
import script from "./ViewMachineResources.vue?vue&type=script&lang=js&"
export * from "./ViewMachineResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b05ccb",
  null
  
)

export default component.exports